import {
    ExternalAuthFlowOptions,
    showExternalAuthError,
    showExternalRegistrationSuccess,
    startExternalAuthFlow
} from 'app/utils/externalAuth';

const ERROR_KEYS = [
    'google_id_required',
    'email_required',
    'google_already_linked',
    'email_already_registered',
    'failed_to_authenticate',
    'google_unavailable'
];

export const startGoogleAuthFlow = (options?: ExternalAuthFlowOptions): void => startExternalAuthFlow(
    '/auth/google_oauth2',
    options
);

export const showGoogleAuthError = (): void => showExternalAuthError('google', ERROR_KEYS);

export const showGoogleRegistrationSuccess = (): void => showExternalRegistrationSuccess('google');
